import styles from "@/styles/contact-us.module.scss"
import Head from "next/head"
import { useEffect, useState, useRef } from "react";
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import { getCookie } from '@/utils/cookie'
import { openLiveChat } from "@/utils/aiLiveChat";
import IconLive from '@/svgs/icon-live.svg'
import IconCall from '@/svgs/icon-call.svg'
import IconEmail from '@/svgs/icon-email.svg'
import { DownOutlined } from '@ant-design/icons';

import ContactForm from "@/components/contact-us/ContactForm"
import Image from 'next/image'
import Link from 'next/link'
import contactApi from '@/service/modules/contactApi'


import getConfig from 'next/config'
import { Button } from "antd";
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
export default function ContactUs() {
  const chatNowRef = useRef<HTMLDivElement>(null);

  const [highlightLiveChat, setHighlightLiveChat] = useState(false);
  const [showMoreContact, setShowMoreContact] = useState(false);
  const [highlightLoading, setHighlightLoading] = useState(false);

  const [isLogin, setIsLogin] = useState(false)
  const [affiliateId, setAffiliateId] = useState<string | null>(null);
  const [currentHour, setCurrentHour] = useState<number>(0);

  useEffect(() => {
    // 获取Live chat是否需要优先展示
    getLiveChatStatus()
  }, []);

  // 获取Live chat是否需要优先展示
  const getLiveChatStatus = async () => {
    try {
      let res = await contactApi.getContactUsChat()
      if (res.data) {
        setHighlightLiveChat(res.data.isShow)

        if (!res.data.isShow) {
          setShowMoreContact(true)
        }
      }
    } catch (error) {
      setShowMoreContact(true)
      console.error(error)
    }
  }

  // 定义点击处理函数，放在组件顶层以便在多个地方使用
  const handleClick = () => {
    // 确保 Shadow Host 元素存在
    const chatBox = document.querySelector('#hello-jekka-chat-box');
    if (!chatBox?.shadowRoot) {
      console.error('Shadow root not found');
      return;
    }

    // 查找 Shadow DOM 中的按钮
    const shadowButton = chatBox.shadowRoot.querySelector('.chat-entry-button');
    if (shadowButton instanceof HTMLElement) {
      shadowButton.click(); // 触发点击
    } else {
      console.error('Chat button not found in shadow DOM');
    }
  };

  const checkHighlightBack = () => {
    const chatBox = document.querySelector('#hello-jekka-chat-box');
    const shadowButton = chatBox?.shadowRoot?.querySelector('.chat-entry-button');
    if(chatBox && shadowButton) {
      handleClick()
      setHighlightLoading(false)
    } else {
      !highlightLoading && setHighlightLoading(true)
      setTimeout(() => {
        checkHighlightBack()
      }, 100);
    }
  }

  // 监听highlightLiveChat状态变化，只有当它为true时才添加事件监听器
  // useEffect(() => {
  //   // 只有当highlightLiveChat为true时才添加事件监听器
  //   if (highlightLiveChat) {
  //     // 确保 #chatNow 元素已挂载
  //     const chatNowElement = chatNowRef.current;
  //     if (chatNowElement) {
  //       chatNowElement.addEventListener('click', handleClick);
  //     }

  //     return () => {
  //       if (chatNowElement) {
  //         chatNowElement.removeEventListener('click', handleClick);
  //       }
  //     };
  //   }
  // }, [highlightLiveChat]); // 依赖highlightLiveChat，当它变化时重新执行

  useEffect(() => {
    // Set current hour
    const hour = new Date().getHours();
    setCurrentHour(hour);

    // Get affiliateId from cookies
    const affiliateCookie = getCookie('affiliateid')
    if (affiliateCookie) {
      setAffiliateId(affiliateCookie || null);
    }

    if (localStorage.getItem('userEmail')) {
      setIsLogin(true)
    }
  }, []);

  return (
    <>
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "@id": "https://www.crazysales.com.au/contact-us#page",
            "url": "https://www.crazysales.com.au/contact-us",
            "name": "Contact Us",
            "description": "Contact CrazySales Customer Service by live chat, phone or email for customer enquiries, before and after sales support.",
            "isPartOf": {
              "@id": "https://www.crazysales.com.au/#website"
            },
            "mainEntity": [
              {
                "@id": "https://www.crazysales.com.au/#phone-contact"
              },
              {
                "@id": "https://www.crazysales.com.au/#live-chat-contact"
              },
              {
                "@id": "https://www.crazysales.com.au/#email-contact"
              }
            ]
          }).replace(/</g, '\\u003c') }} />
        <title>Contact Us</title>
        <meta
          name="description"
          content="Contact CrazySales Customer Service by live chat, phone or email for customer enquiries, before and after sales support."
        ></meta>
        <link rel="canonical" href="https://www.crazysales.com.au/contact-us" key="canonical" />
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-contact-us']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <Image
              className={styles['banner']}
              src={`${imageDomain}/legal/contact-us-banner.png`}
              alt={'coupon-bg'}
              width={1152}
              height={200}
            ></Image>

            {
              highlightLiveChat ? (
                <div 
                  className={styles['online-live-chat-box']}
                  style={{ 
                    background: `url('${imageDomain}/legal/contact-us-livechat-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    }}
                >
                  <div className={styles['chat-title']}>ONLINE LIVE CHAT WITH US</div>
                  <Button loading={highlightLoading} className={styles['chat-btn']} type="primary" id="chatNow" onClick={openLiveChat} >Chat With Us</Button>
                  <div className={styles['chat-desc']}>Real-time communication to quickly solve your problems</div>
                  <div className={styles['chat-time']}>Mondays to Fridays from <span style={{color: '#D50B17', fontWeight: 'bold'}}>9:00 AM to 6:00 PM (AEST)</span></div>
                </div>
              ) : null
            }

            <div className={`${styles['ask-title']} padding-top-12`}>
              Have a question and would like an answer?
            </div>
            <div className={`${styles['ask-title']}`}>
              Please check the FAQ page at our online &nbsp;
              <Link
                href="/article/faq"
                legacyBehavior
              >
                <a className={styles['link']} style={{ fontWeight: "400" }} rel="noopener noreferrer">
                  Help Centre!
                </a>
              </Link>
            </div>
            <div className={styles['answer-desc']}>
              should you like to be in touch with our Customer Service Representatives, feel free to contacl us via either method stated below.
            </div>

            <div className={`${styles['ask-title']} padding-top-12`}>
              Your request ID is {currentHour} - &nbsp;
              <span style={{ fontSize: '30px', color: 'red' }}>
                {affiliateId || 0}
              </span>
            </div>

            <div className={styles['contact-tips']}>
              <div className={styles['icon-box']}>
                <IconLive></IconLive>
              </div>
              <div className={styles['tips-text-box']}>
                <div className={styles['tips-text-title']}>ONLINE LIVE CHAT WITH US</div>
                <div className={styles['tips-text-desc']}>for Customer Enquiries, Before and After Sales</div>
                <div className={styles['tips-text-desc']}>Chat available on Mondays to Fridays from <span style={{color: '#fc4838', fontWeight: '700'}}>9:00AM to 6:00PM (AEST)</span></div>
              </div>
            </div>

            <div className={styles['contact-tips']}>
              <div className={styles['icon-box']}>
                <IconCall></IconCall>
              </div>
              <div className={styles['tips-text-box']}>
                <div className={styles['tips-text-title']}>CALL US ON <span style={{color: '#fc4838', fontWeight: '700', fontSize: '24px'}}>03 91115708</span></div>
                <div className={styles['tips-text-desc']}>Mondays to Fridays from <span style={{fontWeight: '700'}}>8:00AM to 5:00PM (AEST)</span></div>
              </div>
            </div>

            <div className={styles['contact-tips']}>
              <div className={styles['icon-box']}>
                <IconEmail></IconEmail>
              </div>
              <div className={styles['tips-text-box']}>
                <div className={styles['tips-text-desc']}><span style={{fontWeight: '700'}}>SEND US AN EMAIL</span>&nbsp;for All Enquiries</div>
                <div className={styles['tips-text-email']}>Email: info@crazysales.com.au</div>
                <div className={styles['tips-text-desc']}>Your inquiry is important to us and in most cases we are able to <span style={{fontWeight: '700'}}>respond within 24 to 36 business hours</span>, if the enquiry is complex or requires additional information to be requested , your inquiry and any number of other inquiries we may currently have may be extended to to up to 72 business hours for a response. Thanks for your support and consideration.</div>
              </div>
            </div>

            {
              showMoreContact ? (
                <>
                  <div className={`${styles['ask-title']} padding-top-20`}>
                    Contact Our Customer Service Department (<span style={{ color: '#e60917' }}>*</span> required)
                  </div>
                  <div className={styles['answer-desc']}>
                    Please Choose Subject of Your Enquiry: <span style={{ color: '#e60917' }}>*</span>
                  </div>
                  {
                    !isLogin
                    ?
                    <div className={styles['answer-desc']} style={{ fontWeight: '700' }}>
                      Please login ! <Link
                        href="/login?redirect=/contact-us"
                        legacyBehavior
                      >
                        <a className={styles['link']} style={{ fontWeight: "400" }} rel="noopener noreferrer">
                          click here
                        </a>
                      </Link>
                    </div>
                    :
                    null
                  }
                  <ContactForm></ContactForm>
                </>
              ) : (
                <div className={styles['more-contact-box']} onClick={() => setShowMoreContact(true) }>
                  More Contact Details
                  <DownOutlined style={{ marginLeft: '10px' }} />
                </div>
              )
            }
          </div>

        </div>
      </DefaultLayout>
    </>
  )
}
